"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Check that a given date is today's date.
 */
exports.default = (date) => {
    const today = new Date();
    const dateCompare = typeof date === 'string' ? new Date(date) : date;
    return today.getFullYear() === dateCompare.getFullYear() &&
        today.getMonth() === dateCompare.getMonth() &&
        today.getDate() === dateCompare.getDate();
};
